export const FACIAL_HAIR_STYLES = [
  "Clean Shaven",
  "Stubble",
  "Mustache",
  "Beard",
  "Goatee",
  "Full-Beard",
  "Soul-Patch",
  "Mutton-Chops",
] as const;

export type FacialHairStyle = (typeof FACIAL_HAIR_STYLES)[number];

// Legacy type that includes "None" for backward compatibility with old database records
export type FacialHairStyleWithLegacy = FacialHairStyle | "None";
